<template>
  <icon-base :green="colorizeInGreen" :red="!up" :gray="gray">
    <icon-arrow-min-filled :up="up"/>
  </icon-base>
</template>

<script>
import IconArrowMinFilled from './IconArrowMinFilled';

export default {
  props: {
    up: Boolean,
    gray: Boolean,
  },
  components: {
    IconArrowMinFilled,
  },
  computed: {
    colorizeInGreen() {
      return this.up && !this.gray;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/icons/IconTendencyArrow.vue